import { LogReporter } from '@tencent/petrel-family-meals';

let instance = null;
export default class Log {
  static getInstance = () => {
    if (instance) return instance;
    instance = new LogReporter();
    return instance;
  };
}
